import React from 'react';
import { MainTitle } from '.';
import FullPageLink from './FullPageLink';
import routeConstant from '../../constants/route.constants';

const PrivacyStatementModal = () => (
  <div className="modal-content-wrapper">
    <MainTitle>Quyền riêng tư</MainTitle>
    <FullPageLink url={routeConstant.PRIVACY_STATEMENT} />

    <div className="main-content">
      <div id="main_0_DivCode">
        <div>
          <ol style={{ marginBottom: '0px', paddingBottom: '10px' }}>
            <li>
              <h4>Thu thập thông tin</h4>
              Chúng tôi không thu thập thông tin của bạn. Bạn có thể miễn phí sử dụng hệ thống mà
              không cần phải đăng nhập hoặc cung cấp thông tin gì.
            </li>

            <li>
              <h4>Sử dụng thông tin</h4>
              Chúng tôi không sử dụng bất kỳ thông tin nào của bạn. Dữ liệu của bạn được mã hóa, lưu
              trữ và chỉ duy nhất bạn được truy cập.
            </li>

            <li>
              <h4>Thông cáo bên thứ 3</h4>
              <div>
                Chúng tôi không bán, giao thương hoặc chuyển đổi bất kỳ thông tin nào của hệ thống cho bên
                ngoài.
              </div>
              
            </li>

            <li>
              <h4>Bảo mật thông tin</h4>
              Chúng tôi ứng dụng nhiều biện pháp để bảo mật dữ liệu cá nhân người dùng. Cụ thể,
              chúng tôi sử dụng thuật toán mã hóa cao cấp để bảo mật các giao dịch trực tuyến đòi
              hỏi sự bảo vệ cao. Máy tính/các máy chủ dùng để lưu trữ các thông tin cá nhân đều được
              đặt ở môi trường bảo mật.
            </li>
            <li>
              <h4>Chúng tôi có dùng cookies?</h4>
              Câu trả lời là có. Cookies được chúng tôi sử dụng để cải thiện tính tiện dụng cũng như
              giúp nhận diện các lượt đăng nhập lập lại. Ngoài ra, cookies của chúng tôi giúp theo
              dõi cũng như đáp ứng theo nhu cầu riêng của từng người dùng. Tất cả cookie sử dụng đều
              không liên quan tới các thông tin cá nhân trên website của chúng tôi.
            </li>

            {/* <li>
                <h4>Hủy nhận thư</h4>
                Chúng tôi sử dụng địa chỉ email được người dùng cung cấp để gửi các thông tin và cập
                nhật mà người dùng quan tâm như các yêu cầu đặt hàng, các thông tin về doanh
                nghiệp...Nếu bất kỳ khi nào bạn muốn hủy nhận thư, chúng tôi đều đính kèm các hướng
                dẫn hủy nhận thử ở cuối mỗi email.
              </li> */}

            <li>
              <h4>Đồng ý</h4>
              Bằng cách sử dụng trang web của chúng tôi, bạn đã đồng ý với chính sách riêng tư của
              chúng tôi.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyStatementModal;
